var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,19c-1.6,0-3-1.4-3-3c0-0.5,0.1-0.9,0.3-1.3l-1.5-1.5C11.3,14,11,15,11,16c0,2.8,2.2,5,5,5 c1,0,2-0.3,2.8-0.8l-1.5-1.5C16.9,18.9,16.5,19,16,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,11c-1,0-2,0.3-2.8,0.8l1.5,1.5c0.4-0.2,0.8-0.3,1.3-0.3c1.7,0,3,1.3,3,3c0,0.5-0.1,0.9-0.3,1.3l1.5,1.5 C20.7,18,21,17,21,16C21,13.2,18.8,11,16,11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,16c0-4.5-5.9-8-13.5-8c-2.1,0-4.1,0.3-5.8,0.8L5.7,4.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l3.8,3.8 c-3.4,1.4-5.6,3.8-5.6,6.5c0,4.5,5.9,8,13.5,8c2.1,0,4.1-0.3,5.8-0.8l3.5,3.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4l-2.8-2.8C27.3,21.1,29.5,18.7,29.5,16z M16,21c-2.8,0-5-2.2-5-5c0-1,0.3-2,0.8-2.8l1.5,1.5 C13.1,15.1,13,15.5,13,16c0,1.6,1.4,3,3,3c0.5,0,0.9-0.1,1.3-0.3l1.5,1.5C18,20.7,17,21,16,21z M18.7,17.3c0.2-0.4,0.3-0.8,0.3-1.3 c0-1.7-1.3-3-3-3c-0.5,0-0.9,0.1-1.3,0.3l-1.5-1.5C14,11.3,15,11,16,11c2.8,0,5,2.2,5,5c0,1-0.3,2-0.8,2.8L18.7,17.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.92e7ae9dcb79c7ea10a5d6a2b387c6ca.svg";
export { ForwardRef as ReactComponent };